import React from 'react';

import { Box, Typography, Button } from '@mui/material';

import { SelectorType } from '../../../../types/SelectorType';

type SelectorProps = {
  type: SelectorType;
  bottomState: SelectorType;
  label: string;
  setSegment: (state: SelectorType) => void;
};

const SelectorSegment: React.FC<SelectorProps> = ({
  type,
  bottomState,
  label,
  setSegment,
}) => {
  return (
    <Box className='user-codes-selector-button-container'>
      <Button
        disableRipple
        variant='text'
        onClick={() => {
          setSegment(type);
        }}
      >
        <Typography
          sx={{
            color: (theme) =>
              bottomState === type
                ? theme.palette.primary.main
                : theme.palette.text.secondary,
          }}
        >
          {label}
        </Typography>
      </Button>
      {bottomState === type && <Box className='user-codes-selector' />}
    </Box>
  );
};

export default SelectorSegment;
